"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StoreCode = void 0;

var _config = require("@gymshark/config");

var StoreCode;
exports.StoreCode = StoreCode;

(function (StoreCode) {
  StoreCode["S1"] = "s1";
  StoreCode["S2"] = "s2";
  StoreCode["S3"] = "s3";
  StoreCode["S4"] = "s4";
  StoreCode["XD"] = "xd";
  StoreCode["XS"] = "xs";
  StoreCode["XS2"] = "xs2";
  StoreCode["XS3"] = "xs3";
  StoreCode["XS4"] = "xs4";
  StoreCode["AU"] = "au";
  StoreCode["CA"] = "ca";
  StoreCode["DK"] = "dk";
  StoreCode["FI"] = "fi";
  StoreCode["FR"] = "fr";
  StoreCode["DE"] = "de";
  StoreCode["IE"] = "ie";
  StoreCode["NL"] = "nl";
  StoreCode["NO"] = "no";
  StoreCode["SE"] = "se";
  StoreCode["CH"] = "ch";
  StoreCode["GB"] = "gb";
  StoreCode["US"] = "us";
  StoreCode["EU"] = "eu";
  StoreCode["RW"] = "rw";
})(StoreCode || (exports.StoreCode = StoreCode = {}));

var checkStoreCode = function checkStoreCode(storeCode) {
  return _config.STAGING_STORES[storeCode] ? _config.STAGING_STORES[storeCode].liveStoreCode : storeCode;
};

exports["default"] = checkStoreCode;